import React, { useEffect, useState } from 'react';
import { SlIcon } from '@shoelace-style/shoelace/dist/react';

/**
 * Square media preview that degrades gracefully. A dead CDN URL renders a
 * placeholder tile of exactly the same size, so the row/grid never reflows.
 */
const MediaThumb = ({
  src,
  isVideo = false,
  alt = 'creative',
  className = 'h-12 w-12',
  rounded = 'rounded-lg',
  onClick,
}) => {
  const [broken, setBroken] = useState(false);

  useEffect(() => {
    setBroken(false);
  }, [src]);

  const base = `relative flex shrink-0 items-center justify-center overflow-hidden border border-slate-200 bg-slate-50 ${rounded} ${className}`;

  if (!src || broken) {
    return (
      <div className={base} title={!src ? 'No design uploaded yet' : 'Preview unavailable'}>
        <SlIcon
          library="lucide"
          name={isVideo ? 'video-off' : 'image-off'}
          className="text-slate-300"
          style={{ fontSize: '18px' }}
        />
      </div>
    );
  }

  const interactive = typeof onClick === 'function';

  return (
    <div
      className={`${base} ${interactive ? 'cursor-zoom-in' : ''}`}
      onClick={interactive ? onClick : undefined}
      onKeyDown={
        interactive
          ? (e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                onClick(e);
              }
            }
          : undefined
      }
      role={interactive ? 'button' : undefined}
      tabIndex={interactive ? 0 : undefined}
    >
      <img
        src={src}
        alt={alt}
        loading="lazy"
        onError={() => setBroken(true)}
        className="h-full w-full object-cover"
      />
      {isVideo && (
        <span className="absolute inset-0 flex items-center justify-center bg-black/25">
          <SlIcon library="lucide" name="play" className="text-white" style={{ fontSize: '14px' }} />
        </span>
      )}
    </div>
  );
};

export default MediaThumb;
